import { AssignTasks } from '../../modules/AssignTasks';
import { appConfig as $config } from '../../app.config';
import { edit } from './edit';
import { UI } from '../../modules/UI';
import { Common } from '../../modules/Common';
import { App } from '../../modules/App';
import { User } from '../../modules/User';
import { SortFilter } from '../../modules/SortFilter';
import { QuickFilters } from '../../modules/SortFilter/quick-filters';
import { ArtworkInfo } from '../../modules/ArtworkInfo';
import { ItemCardNotice } from '../../modules/ItemCardNotice';
import { ApprovalRejection } from '../../modules/ApprovalRejection';
import { ApprovalPDF } from '../../modules/ApprovalPDF';
import { mockupCreateErrorsModal } from '../../modules/ReactComponent';
import { Trims } from '../Trims';
import { Blanks } from '../Blanks';

import './scss/artworks.scss';

export const Artworks = (function () {
  let $pageParams = {};
  let $pageQuery = '';
  let $reactFeatures = {};
  let $withTrims = false;
  let $isPattern = false;
  let $isLicensor = '';

  let setReactFeatures = (data) => {
    $reactFeatures = data;
  };

  let mapping = {
    artworks: (data) => {
      return $.map(data, function (arts) {
        arts.createDateText = moment(arts.createdDate).format('MMM DD, YYYY');
        arts.isHaveLow = false;
        arts.isHaveHight = false;
        arts.isHaveAi = false;
        arts.apiUrl = $config.apiURL;
        arts.externalSourceType = $config.externalSourceType;
        arts.checked = window['DT'].selectArtworks
          ? window['DT'].selectArtworks.find((o) => {
              return o.id == arts.id;
            }) !== undefined
          : false;
        arts.submitState.changedDateText = '';
        arts.mockupGenerateProcessState =
          arts.mockupGenerateProcessState != null ? arts.mockupGenerateProcessState : { state: -1, precent: '0%' };
        if (arts.submitState.changedDate != null) {
          arts.submitState.changedDateText = KTUtil.getLocalDateTime(
            arts.submitState.changedDate,
            'en-US',
            'YYYY-MM-DD'
          );
        }
        if (arts.files) {
          for (let i = 0; i < arts.files.length; i++) {
            arts.isHaveLow = arts.isHaveLow || (arts.files[i].fileType == 0 && arts.files[i].uri != '');
            arts.isHaveHight = arts.isHaveHight || (arts.files[i].fileType == 1 && arts.files[i].uri != '');
            arts.isHaveAi = arts.isHaveAi || (arts.files[i].fileType == 2 && arts.files[i].uri != '');
          }
        }
        // Approval Item mapping
        arts.approveItem = Common.mapping.approvalObject(arts.approveItem);

        // images
        arts.availableImages = (arts.versionFiles || [])
          .sort((a, b) => (a.colorGroup < b.colorGroup ? -1 : 1))
          .map((v) => v.thumbnailImageUri);

        return arts;
      });
    }
  };

  let init = (params = {}, query = '', cb = null) => {
    $pageParams = params;
    $pageQuery = query;
    $withTrims = params.withTrims;
    $isPattern = params.isPattern;

    $isLicensor = User.isLicensor();

    QuickFilters.setSyncFilters({
      licensorFilters: ['Brand', 'Subbrand', 'LicenseOwner'],
      licenseeFilters: ['Licensor', 'Brand', 'Subbrand'],
    });

    if (!params || (params && params.action != 'dialog')) {
      UI.block('#page');

      loadApprovalPDFTemplates();
    } else {
      UI.block('.modal-content');

      QuickFilters.setSyncFilters({
        licensorFilters: [],
        licenseeFilters: [],
      });
    }

    //UI.offPageLeaveHandler();

    let selectArtworks = App.pageData('selectArtworks');
    if (!selectArtworks) {
      App.pageData('selectArtworks', []);
    }

    if (params && params.action && params.id) {
      if (params.action?.includes?.('edit')) {
        return edit.page(params.id, params.accountId, params.action);
      } else if (params.action?.includes?.('add')) {
        return edit.page(null, null, params.action);
      }
    }

    loadData(params, query, cb);
  };

  let loadData = (params = {}, query = '', cb = null) => {
    let requestData = {};
    let responseMapper = null;

    if (params && params.action == 'dialog') {
      requestData.requestPage = 'artworks';
      requestData.isExcludeRejected = true;
      if (!params.reload) {
        requestData.page = 1;
      }
    }

    if (typeof $isPattern !== 'undefined') {
      responseMapper = aopResponseMapper;

      if ($isPattern) {
        requestData = prepareRequestData(requestData, 'Pattern');
      } else {
        requestData = prepareRequestData(requestData, 'Central');
      }
    }

    $.when(App.ajaxData(
      `artworks/filter`,
      requestData,
      'POST',
      'application/json',
      null,
      responseMapper,
      typeof $isPattern !== 'undefined'
    )).done((pageData) => {
      pageData.isLicensor = $isLicensor;
      pageData.data = mapping.artworks(pageData.data);
      pageData.approvalPDFTemplates = App.pageData('approvalPDFTemplates') || [];
      actionsInit();

      if (params && params.action == 'dialog') {
        App.pageData('artworks', pageData.data);
        pageData = {
          ...pageData,
          ...{
            dialog: true,
            callback: params.callback,
            onHide: params.onHide,
            withTrims: $withTrims,
            isPattern: $isPattern,
            reload: params.reload,
            query: query,
            $lang: $lang
          }
        };
        return dialogPage(pageData);
      }

      let template = require('./tmpl/artworks.hbs');
      UI.page(template, pageData).then(() => {
        App.pageData('artworks', pageData.data);
        App.pageData('selectArtworks', []);
        App.pageData('selectAllArtworks', false);
        pageinit(pageData);
        actionsInit();

        if (typeof cb === 'function') {
          cb();
        }
      });
    });
  };

  let loadApprovalPDFTemplates = () => {
    ApprovalPDF.loadTemplates()
      .then((templates) => {
        App.pageData('approvalPDFTemplates', templates);

        if (templates?.length) {
          $(`.js-action-approval-pdf`).removeClass('d-none');
        } else {
          $(`.js-action-approval-pdf`).addClass('d-none');
        }
      });
  };

  let pageinit = (pageData) => {
    // Variants images
    $('.card-owl-carousel').owlCarousel({
      items: 1,
      dots: false,
      nav: true,
      margin: 0
    });

    //ZOOM-IN
    UI.zoomInInit('zoomimage');

    // Page in dialog
    if (pageData.dialog) {
      Common.paginationDialog({
        paginationWraper: '.artworksPaging',
        pagename: 'artworks',
        action: reloadDialog
      });

      SortFilter.init({
        selector: '#searchFormArtworks',
        pagename: 'artworks',
        update: reloadDialogWithClearingSelectAll
      });

      $('.modal-artworks-page .modal-body').scrollTop(0);
      UI.unblock('.modal-content');

      $('.js-action-goToTrim').on('click', goToTrim.bind(this, pageData));

      // Standart Page
    } else {
      QuickFilters.init({ selector: '#artworkQuickFilters' });

      // Reload content
      if (pageData.pageReload) {
        SortFilter.updateCheckBoxLists();
        UI.unblock('#page');
        return;
      } else {
        $('#page')
          .off()
          .on('click', '.js-action-assigntask', assignTask)
          .on('click', '.js-action-approval-pdf', approvalPDF)
          .on('click', '.js-action-approvereject', approveReject)
          .on('click', '.card-item .js-artwork-submit', submitSingle)
          .on('dblclick', '.card-item-artwork .js-artworkinfo-dialog', dialogInfo)
          .on('click', '.js-action-edit', editArtwork);

        SortFilter.init({
          selector: '#searchFormArtworks',
          update: reloadPageWithClearingSelectAll,
          isLicensorSelect: true
        });

        $('#centralElementAddBtn')
          .off()
          .on('click', () => {
            $router.push('/artworks/0/add-central');
          });
        $('#patternAddBtn')
          .off()
          .on('click', () => {
            $router.push('/artworks/0/add-pattern');
          });
        $('#complexArtworkAddBtn')
          .off()
          .on('click', () => {
            $router.push('/artworks/0/add-complex');
          });
        $('#artworksSubmitBtn')
          .off()
          .on('click', () => {
            submitClickHandler();
          });
      }

      UI.unblock('#page');
    }
  };

  let reloadPage = () => {
    App.ajaxAbortAll();
    UI.block('#page');

    let selectArtworks = App.pageData('selectArtworks') || [];
    let selectAllArtworks = App.pageData('selectAllArtworks') || false;

    $.when(App.ajaxData(`artworks/filter`, {}, 'POST')).done((pageData) => {
      // Mapping Page Data
      pageData.data = mapping.artworks(pageData.data);

      let template = require('./tmpl/partial/content.hbs');
      UI.render('#pageContentArtworks', template, pageData).then(() => {
        App.pageData('artworks', pageData.data);
        App.pageData('selectArtworks', selectArtworks);
        App.pageData('selectAllArtworks', selectAllArtworks);

        pageinit({ pageReload: true });
        actionsInit();
      });
    });
  };

  let reloadPageWithClearingSelectAll = () => {
    App.pageData('selectArtworks', []);
    App.pageData('selectAllArtworks', false);
    reloadPage();
  };

  let reloadDialogWithClearingSelectAll = () => {
    App.pageData('selectArtworks', []);
    App.pageData('selectAllArtworks', false);
    reloadDialog();
  };

  let reloadDialog = (query = '') => {
    UI.block('.modal-content');
    loadData({ action: 'dialog', reload: true }, query);
  };

  let dialogPage = (pageData) => {
    let template = require('./tmpl/artworks.hbs');

    if (pageData.reload) {
      UI.render('.modal-artworks-page .bootbox-body', template, pageData).then(() => {
        pageinit(pageData);
      });
      return;
    }

    bootbox.hideAll();

    bootbox
      .dialog({
        title: !pageData.isPattern ? $lang.ministu.SelectArtwork : $lang.ministu.SelectPatterns,
        message: template(pageData),
        animate: !$withTrims,
        size: 'xl',
        className: 'modal-scrolled-content modal-artworks-page',
        onHide: (e) => {
          SortFilter.clear('artworks');

          if (pageData.onHide) {
            pageData.onHide();
          }
        },
        buttons: {
          Ok: {
            label: `<i class="fal fa-check-double"></i> ${$lang.btn.applay}`,
            className: 'btn btn-primary',
            callback: pageData.callback
          },
          Close: {
            label: `<i class="fal fa-times"></i> ${$lang.btn.cancel}`,
            className: 'btn btn-default'
          }
        }
      })
      .init(() => {
        pageinit(pageData);
      });
  };

  let dialogInfo = (e) => {
    let thisEl = $(e.target).hasClass('card-item') ? $(e.target) : $(e.target).closest('.card-item');
    let id = thisEl.data('itemid');

    const artwork = (App.pageData('artworks') || []).find(a => a.id === id);

    if (!id || !artwork) return alert('Artwork not find');

    ArtworkInfo.dialog(id, reloadPage, false, artwork.accountId);
  };

  let editArtwork = (e) => {
    let thisEl = $(e.target).hasClass('card-item') ? $(e.target) : $(e.target).closest('.card-item');
    let id = thisEl.data('itemid');

    const artwork = (App.pageData('artworks') || []).find(a => a.id === id);

    $router.push(`/artworks/${artwork.id}/${artwork.accountId}/edit-${artwork.artworkType?.toLowerCase?.()}`);
  };

  let deleteArt = (id = false, isConfirm = false) => {
    let idsCollection = {};

    if (id) {
      const artwork = (App.pageData('artworks') || []).find(a => a.id === id);

      if (artwork) {
        idsCollection[id] = artwork?.accountId;
      }
    } else {
      let selectArtworks = App.pageData('selectArtworks') || [];
      idsCollection = selectArtworks.reduce((acc, artwork) => {
        acc[artwork.id] = artwork.accountId;
        return acc;
      }, {});
    }

    if (!Object.keys(idsCollection).length) {
      UI.unblock('#page');
      return;
    }

    if (isConfirm) {
      return deleteArtwork(idsCollection, true);
    }

    let title = 'selected Artworks';
    if (id) {
      let artw = _.findWhere(App.pageData('artworks'), { id: id });
      if (artw.title) title = artw.title;
    }

    UI.deleteConfirm(title).then((yes) => {
      if (yes) {
        deleteArtwork(idsCollection, false);
      }
    });
  };

  let deleteArtwork = (ids, isConfirm) => {
    UI.block('#page');

    $.when(App.ajaxData('/artworks/delete', { ids, isConfirm: isConfirm }, 'POST')).done((res) => {
      if (res.confirmText) {
        bootbox.confirm({
          message: `<h4 class="text-danger">${res.confirmText}</h4>`,
          buttons: {
            confirm: {
              label: 'Yes',
              className: 'btn-success'
            },
            cancel: {
              label: 'No',
              className: 'btn-danger'
            }
          },
          callback: function (result) {
            if (result) {
              let selectArtworks = App.pageData('selectArtworks') || [];
              if (selectArtworks.length == 0) {
                deleteArt(ids[0], true);
              } else {
                deleteArt(false, true);
              }
            } else {
              UI.unblock('#page');
            }
          }
        });
      } else {
        let selectArtworks = [];
        if (ids.length == 1) {
          // If was selected - remove from selected Array
          selectArtworks = selectArtworks.filter((item) => {
            if (item.id != ids[0]) return item;
          });
        }

        UI.notify({ text: $lang.alert.SuccessfullySaved, type: 'success' });

        App.pageData('selectAllArtworks', false);
        App.pageData('selectArtworks', selectArtworks);
        reloadPage();
      }
    });
  };

  let selectAll = (event) => {
    let isCheked = $(event.currentTarget).prop('checked');

    App.pageData('selectAllArtworks', isCheked);

    if (!isCheked) {
      App.pageData('selectArtworks', []);
      return;
    }

    UI.block('#page');
    $.when(App.ajaxData(`/artworks/select/all/${User.accountID()}`, {}, 'POST'))
      .done((res) => {
        App.pageData('selectArtworks', res.data);
      })
      .always(() => {
        actionsInit();
        UI.unblock('#page');
      });
  };

  let submitSingle = (e) => {
    e.preventDefault();
    let id = $(e.target).closest('.card-item').data('itemid');
    submitClickHandler(id);
  };

  let goToTrim = (pageData, e) => {
    let parms = {
      action: 'dialog',
      callback: pageData.callback,
      typeModal: 'trims',
      trimsonly: true,
      withArtworks: true,
    };

    return Trims.init(parms);
  };

  let submitClickHandler = (id = false) => {
    const artworkId = id || App.pageData('selectArtworks')[0].id;

    const artwork = (App.pageData('artworks') || []).find(a => a.id === artworkId);

    if (!artworkId || !artwork) return alert('Artwork not find');

    editBlanksDialog(artwork);
  };

  let submit = (artworkId, artwork, blankIds) => {
    ItemCardNotice.loader({ id: artworkId });

    const handleSuccess = () => {
      App.pageData('selectAllArtworks', false);
      App.pageData('selectArtworks', []);

      UI.notify({ text: $lang.alert.ProcessCreatingStarted, type: 'info', icon: 'fal fa-sync' });
    };

    const handleError = (res) => {
      let text = res.errorInformation.errorReason;
      ItemCardNotice.error({ id: artworkId, text: text });
    };

    $.when(App.ajaxData(`/artworks/submit/${artwork.accountId}`, { artworkId, blankIds }, 'POST')).done((res) => {
      if (res.isSuccess) {
        handleSuccess();
      } else {
        handleError(res);

        const isErrorModal =
          res.errorInformation !== null &&
          res.errorInformation.errorDataType === 'Specific' &&
          Array.isArray(res.errorInformation.errorData[0].errorList) &&
          res.errorInformation.errorData[0].errorList.some(
            (specificError) =>
              specificError.errorCode === 'RejectedBlank' ||
              specificError.errorCode === 'NameNotUnique' ||
              specificError.errorCode === 'MockupConfigurationMatches'
          );

        if (isErrorModal) {
          ItemCardNotice.loader({ id: artworkId, show: false });
          const errorData = res.errorInformation.errorData[0];

          const onContinue = (blankIds) => {
            ItemCardNotice.loader({ id: artworkId });
            $.when(App.ajaxData(`/artworks/submit/${User.accountID()}`, { artworkId, blankIds }, 'POST')).done(
              (res) => {
                if (res.isSuccess) {
                  handleSuccess();
                } else {
                  handleError(res);
                }
              }
            );
          };

          const onClose = () => {
            App.pageData('selectAllArtworks', false);
            App.pageData('selectArtworks', []);
          };

          mockupCreateErrorsModal.init('mockup-create-errors-modal', { errorData, onContinue, onClose });
        }
      }
    });
  };

  let editBlanksDialog = (artwork) => {
    UI.block('#page');

    App.pageData('currenteditedcontent.selectBlanks', []);
    App.pageData('editArtworkBlanksIds', []);
    App.pageData('selectBlanksAll', false);

    let sortingpage = $storage.get('sortingpage_artworks') || {};
    let filtersgpage = $storage.get('filterspage_artworks') || [];

    Blanks.init({
      action: 'dialog',
      selectBlanks: [],
      isDetachedFromAccountBlanks: artwork.isDetachedFromAccountBlanks || false,
      isDTGOnly: artwork.artworkType === 'Central',
      callback: (result) => {
        if (!result) {
          $storage.set('sortingpage_artworks', sortingpage);
          $storage.set('filterspage_artworks', filtersgpage);

          SortFilter.init({
            selector: '#searchFormArtworks',
            update: reloadPageWithClearingSelectAll,
            isLicensorSelect: true
          });

          return;
        }

        let selectBlanksIds = App.pageData('editArtworkBlanksIds');
        App.pageData('editArtworkBlanksIds', []);

        submit(artwork.id, artwork, selectBlanksIds || []);
      }
    });
  };


  let actionsInit = () => {
    let selectArtworks = App.pageData('selectArtworks');
    let isActiveActions = selectArtworks && selectArtworks.length;
    if (!isActiveActions) {
      App.pageData('isActiveActions', false);
      return;
    }
    for (let i = 0; i < selectArtworks.length; i++) {
      let item = selectArtworks[i];

      if (item.approveType > 1) {
        isActiveActions = false;
        break;
      }
    }
    App.pageData('isActiveActions', isActiveActions);
  };

  let assignTask = (e) => {
    AssignTasks.handleAssignTask({
      e: e,
      elClassName: 'js-action-assigntask',
      selectedPageField: 'selectArtworks',
      requestPage: 2
    });
  };

  let approvalPDF = (e) => {
    const selectAllArtworks = App.pageData('selectAllArtworks') || false;
    const selectArtworks = App.pageData('selectArtworks') || [];
    const artworks = App.pageData('artworks') || [];

    const artworkIds = (selectAllArtworks ? artworks : selectArtworks).map((a) => a.id);

    ApprovalPDF.dialog(artworkIds);
  };

  let approveReject = (e) => {
    let target = $(e.target).hasClass('js-action-approvereject')
      ? $(e.target)
      : $(e.target).closest('.js-action-approvereject');
    let id = target.data('itemid');

    const singleItem = id ? App.pageData('artworks').find((i) => i.id == id) : null;
    const selectedItems = singleItem ? [singleItem] : App.pageData('selectArtworks');
    const mapped = selectedItems.reduce((acc, item) => ({ ...acc, [item.id]: item.accountId }), {});

    ApprovalRejection.dialog({
      items: mapped,
      page: 'artworks',
      callback: reloadPageWithClearingSelectAll
    });
  };

  let aopResponseMapper = (responseData) => {
    const excludedFilterItems = ['ArtworkType'];

    if (!responseData?.responseObject) {
      return {
        ...responseData,
        filterData: {
          sortItems: [...(responseData?.filterData?.sortItems || [])],
          filterItems: [
            ...(responseData?.filterData?.filterItems || []).filter((f) => !excludedFilterItems.includes(f.internalName))
          ]
        }
      };
    }
  };

  let prepareRequestData = (requestData, artworkType) => {
    const dataWithFilter = SortFilter.prepareQuery(requestData);

    if (Array.isArray(dataWithFilter.filterItems)) {
      const hasArtworkTypeFilter = dataWithFilter.filterItems.some(f => f.internalName === 'ArtworkType');

      if (!hasArtworkTypeFilter) {
        dataWithFilter.filterItems.push({
          internalName: 'ArtworkType',
          values: [artworkType]
        });
      }
    }

    return dataWithFilter;
  };

  let clear = () => {
    edit.clear();
  };

  return {
    init,
    clear,
    setReactFeatures,
    pageinit,
    deleteArt,
    selectAll,
    submitClickHandler,
    actionsInit,
    assignTask
  };
})();
